import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  alertsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

export default useStyles
